import { FC } from 'react';
import classNames from 'classnames';

import { ChildrenPropType } from 'src/utils/types';
import { UiButton } from 'src/components/UI/Button';
import { TemplateGalleryArrowIcon } from 'src/components/Modals/TemplateGallery/icons/Arrow';
import styles from 'src/styles/common/templateGallery.module.scss';

type Props = {
  children: ChildrenPropType;
  onClick: () => void;
  className?: string;
};

export const TemplateGalleryLinkButton: FC<Props> = ({ children, onClick, className }) => (
  <UiButton notBtn className={classNames(styles.linkButton, className)} onClick={onClick}>
    <TemplateGalleryArrowIcon className={styles.linkButtonIcon} />
    <span>{children}</span>
  </UiButton>
);
